import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderCake } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { UpdateOrderItemRequest, UpdateOrderItemResponse } from './interface';

export const updateOrderItem = createAsyncThunk(
  'orderItem/updateOrderItem',
  async (request: UpdateOrderItemRequest, { rejectWithValue }) => {
    try {
      console.log('Updating order cake:', request);
      
      // Prepare the complete data object with all required fields
      const updateData = {
        shapeId: request.cakeData.shapeId,
        flavorId: request.cakeData.flavorId,
        toppingId: request.cakeData.toppingId || '',
        colorCode: request.cakeData.colorCode,
        writeOnCake: request.cakeData.writeOnCake || '',
        instruction: request.cakeData.instruction || '',
        printImageUrl: request.cakeData.printImageUrl || '',
        displayMode: request.cakeData.displayMode || 'front',
        // Include labels if provided, otherwise they will be populated from the IDs
        shapeLabelEn: request.cakeData.shapeLabelEn || '',
        shapeLabelAr: request.cakeData.shapeLabelAr || '',
        flavorLabelEn: request.cakeData.flavorLabelEn || '',
        flavorLabelAr: request.cakeData.flavorLabelAr || '',
        categoryId: request.cakeData.categoryId || '',
        categoryCakeId: request.cakeData.categoryCakeId || ''
      };
      
      // Use the OrderCake service with PATCH method for cake-specific updates
      const response = await OrderCake.patch(request.orderCakeId, updateData);

      console.log('Order cake update response:', response);
      
      const updateResponse: UpdateOrderItemResponse = {
        id: response.id,
        orderCakeId: request.orderCakeId,
        updatedData: {
          flavorId: request.cakeData.flavorId || '',
          shapeId: request.cakeData.shapeId || '',
          toppingId: request.cakeData.toppingId || '',
          colorCode: request.cakeData.colorCode || '',
          writeOnCake: request.cakeData.writeOnCake || '',
        },
        success: true,
        message: 'Order cake updated successfully'
      };

      return updateResponse;
    } catch (error: any) {
      console.error('Error updating order cake:', error);
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

// Alternative API call using OrderCake service directly
export const updateOrderItemDirect = createAsyncThunk(
  'orderItem/updateOrderItemDirect',
  async (request: UpdateOrderItemRequest, { rejectWithValue }) => {
    try {
      console.log('Updating order cake directly:', request);
      
      // Use the OrderCake service directly for cake data updates
      const response = await OrderCake.patch(request.orderCakeId, request.cakeData);

      console.log('Direct order cake update response:', response);
      
      const updateResponse: UpdateOrderItemResponse = {
        id: response.id,
        orderCakeId: request.orderCakeId,
        updatedData: {
          flavorId: request.cakeData.flavorId || '',
          shapeId: request.cakeData.shapeId || '',
          toppingId: request.cakeData.toppingId || '',
          colorCode: request.cakeData.colorCode || '',
          writeOnCake: request.cakeData.writeOnCake || '',
        },
        success: true,
        message: 'Order cake updated successfully'
      };

      return updateResponse;
    } catch (error: any) {
      console.error('Error updating order cake directly:', error);
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);